@if (isForceUpdate) {
  <div>
    <div class="c-updateVersionModal">
      <div class="c-updateVersionModal_background">
        <span class="modal-title forceUpdate">{{
          'home.lobby.modals.update-native-version.title' | translate | uppercase
        }}</span>
        <span class="modal-subtitle">{{ 'home.lobby.modals.update-native-version.subtitle' | translate }}</span>
      </div>
      <slotcom-button
        class="c-button--pink"
        (click)="redirectToStore()"
        audioType="functionality">
        {{ 'home.buttons.update' | translate | uppercase }}
      </slotcom-button>
    </div>
  </div>
} @else {
  <div class="c-updateVersionModal">
    <div class="c-updateVersionModal_background">
      <span class="modal-title">{{ 'home.lobby.modals.update-version.title' | translate | uppercase }}</span>
      <span class="modal-title-2">{{ 'home.lobby.modals.update-version.title-2' | translate | uppercase }}</span>
      <span class="modal-subtitle">{{ 'home.lobby.modals.update-version.subtitle' | translate }}</span>
    </div>
    <slotcom-button
      class="c-button--pink"
      (click)="closeModal()"
      audioType="functionality">
      {{ 'home.buttons.go-ahead' | translate | uppercase }}
    </slotcom-button>
  </div>
}
